export enum PLATFORM_TYPE_ENUM {
  ANDROID = 0,
  IOS = 1,
}
